import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=8cbddefa&scoped=true&"
import script from "./Thread.vue?vue&type=script&lang=js&"
export * from "./Thread.vue?vue&type=script&lang=js&"
import style0 from "./Thread.vue?vue&type=style&index=0&id=8cbddefa&prod&scoped=true&lang=scss&"
import style1 from "./Thread.vue?vue&type=style&index=1&id=8cbddefa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbddefa",
  null
  
)

export default component.exports